import moment from 'moment-mini';

/**
 * Init date to utc
 * @param date
 * @returns
 */
export function initialFormat(date?: string | number, language?) {
    const currentLanguage = language ? language : 'en';
    // const language = 'fr';

    const momentLocales = {
        bg: {
            months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
                '_'
            ),
            monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split(
                '_'
            ),
            weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
                '_'
            ),
            weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
            weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
            longDateFormat: {
                LT: 'H:mm',
                LTS: 'H:mm:ss',
                L: 'D.MM.YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY H:mm',
                LLLL: 'dddd, D MMMM YYYY H:mm',
            },
            week: {
                dow: 1, // Monday is the first day of the week.
                doy: 7, // The week that contains Jan 7th is the first week of the year.
            },
        },
        fr: {
            months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
                '_'
            ),
            monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
            monthsParseExact: true,
            weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split(
                '_'
            ),
            weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
            weekdaysMin: 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
            weekdaysParseExact: true,
            longDateFormat: {
                LT: 'HH:mm',
                LTS: 'HH:mm:ss',
                L: 'DD/MM/YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY HH:mm',
                LLLL: 'dddd D MMMM YYYY HH:mm',
            },
            week: {
                dow: 1, // Monday is the first day of the week.
                doy: 4, // Used to determine first week of the year.
            },
        },
        ro: {
            months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
                '_'
            ),
            monthsShort: 'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
                '_'
            ),
            weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split(
                '_'
            ),
            weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
            weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
            longDateFormat: {
                LT: 'H:mm',
                LTS: 'H:mm:ss',
                L: 'D.MM.YYYY',
                LL: 'D MMMM YYYY',
                LLL: 'D MMMM YYYY H:mm',
                LLLL: 'dddd, D MMMM YYYY H:mm',
            },
            week: {
                dow: 1, // Monday is the first day of the week.
                doy: 7, // The week that contains Jan 7th is the first week of the year.
            },
        },
        hu: {
            months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
                '_'
            ),
            monthsShort: 'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
                '_'
            ),
            monthsParseExact: true,
            weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split(
                '_'
            ),
            weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
            weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
            longDateFormat: {
                LT: 'H:mm',
                LTS: 'H:mm:ss',
                L: 'YYYY.MM.DD.',
                LL: 'YYYY. MMMM D.',
                LLL: 'YYYY. MMMM D. H:mm',
                LLLL: 'YYYY. MMMM D., dddd H:mm',
            },
            week: {
                dow: 1, // Monday is the first day of the week.
                doy: 4, // The week that contains Jan 4th is the first week of the year.
            },
        },
    };

	if (currentLanguage != 'en') {
		moment.locale(currentLanguage, momentLocales[currentLanguage]);
	}

    if (typeof date === 'string' && date.length) {
        date = new Date(date).getTime();
        return moment.utc(date);
    } else if (typeof date === 'number') {
        return moment.unix(date).utc();
    } else {
        return moment.utc();
    }
}

/**
 * Format date as a string in passed format
 * @param date
 * @param format
 * @returns
 */
export function formatDate(
    date: string | number,
    format: string | undefined,
    language?
): string {
    return initialFormat(date, language).format(format);
}

/**
 * Return range between two dates in minutes
 * @param startDate
 * @param endDate
 * @returns
 */
export function getTwoDatesRange(startDate, endDate) {
    try {
        startDate = moment(startDate);
        endDate = moment(endDate);
        const duration = moment.duration(startDate.diff(endDate));
        const mins = duration.asMinutes();

        return Math.floor(Math.abs(mins));

    } catch (err) {
        return null;
    }
    
}

/**
 * Format date as a string in passed format
 * @param date unixTimestamp
 * @param locale 'en-US'
 * @returns
 */
export function formatYearAndMonthByLocale(
    date: number,
    locale: string
): string {
    if (!locale) return '';

    let dateTimeFormat;

    try {
        dateTimeFormat = new Intl.DateTimeFormat(locale.replace('_', '-'), {
            year: 'numeric',
            month: 'long',
        });
    } catch (e) {
        return '';
    }

    const dateMapingParts = new Map();
    const unixTimestamp = date;
    const milliseconds = unixTimestamp * 1000;
    const dateObject = new Date(milliseconds);

    const parts = dateTimeFormat.formatToParts(dateObject);
    parts.map((p) =>
        p.value.trim().length !== 0
            ? dateMapingParts.set(p.type, p.value)
            : null
    );

    return dateMapingParts.get('month') + ' ' + dateMapingParts.get('year');
}

/**
 * Returns wether the date is before current
 * @param date
 * @returns
 */
export function isInPast(date: string | number): boolean {
    return initialFormat(date).isBefore(moment().utc());
}

/**
 * Returns wether the date is after current
 * @param date
 * @returns
 */
export function isInFuture(date: string | number): boolean {
    return initialFormat(date).isAfter(moment().utc());
}

/**
 * Get year of full date
 * @param date
 * @returns
 */
export function getFullYear(date?: string | number) {
    return initialFormat(date).year();
}

/**
 * Get month by index
 * @param monthIndex
 * @returns
 */
export function getMonth(monthIndex, language?) {
    return initialFormat('', language).month(monthIndex).format('MMMM');
}

/**
 * Get range for past bookings filter // FIX - this is not CORE functionality
 * @param month
 * @param year
 * @returns
 */
export function getBookingsFilterRange(month, year) {
    let filterYear = year ? year : initialFormat().year(),
        filterMonth = month ? month : 0, // set to january if month is not present
        rangeFullYear = month ? false : true, // set flag for full year range if month is not present
        pureStartDate = moment([filterYear, filterMonth]),
        lastMonthPureStartDate = moment([filterYear, 11]), // get first day of last month of year for start date
        startDate = moment([filterYear, filterMonth]).utc().unix(),
        endDate = moment(rangeFullYear ? lastMonthPureStartDate : pureStartDate)
            .endOf('month')
            .utc()
            .unix(); // if month is not present endDate will be end of year

    if (!year && !month) {
        startDate = 0;
        endDate = 0;
    }
    let range = {
        fromDate: startDate,
        toDate: endDate,
    };

    return range;
}
